import { createStore } from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem('token') || null
  },
  getters: {
    getToken: (state) => state.token
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    clearAuth(state) {
      state.token = null
      localStorage.removeItem('token')
    }
  },
  actions: {
  },
  modules: {
  }
}) 